import { render, staticRenderFns } from "./NoticeModal.vue?vue&type=template&id=068b6af3&"
import script from "./NoticeModal.vue?vue&type=script&lang=ts&"
export * from "./NoticeModal.vue?vue&type=script&lang=ts&"
import style0 from "./NoticeModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports